import { AdvancedFilterButton } from '@/components/common/AdvancedFilter';
import { PageHeader } from '@/components/layout/PageHeader';

interface FeedbackListHeaderProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  filterOpen: boolean;
  onFilterToggle: () => void;
  activeFilterCount: number;
}

export function FeedbackListHeader({
  searchText,
  onSearchChange,
  filterOpen,
  onFilterToggle,
  activeFilterCount,
}: FeedbackListHeaderProps) {
  return (
    <PageHeader
      title="Feedbacks"
      search={{ value: searchText, onChange: onSearchChange, placeholder: 'Search in messages' }}
      actions={
        <AdvancedFilterButton
          isOpen={filterOpen}
          activeCount={activeFilterCount}
          onClick={onFilterToggle}
        />
      }
    />
  );
}
